import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Icon } from '@iconify/react';

export default function Certificates() {
  const [certificates, setCertificates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/certificates.json')
      .then(res => res.json())
      .then(data => {
        setCertificates(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Loading certificates...</div>;

  return (
    <section className="certificates-page">
      {/* Background Shapes */}
      <div className="bg-shape-1"></div>
      <div className="bg-shape-2"></div>

      <div className="container">
        <Helmet>
          <title>Certifications & Achievements | Kunal Das</title>
          <meta name="description" content="A collection of professional certifications, accomplishments, and skills verified by industry-leading organizations." />
          <meta property="og:title" content="Certifications & Achievements | Kunal Das" />
          <meta property="og:description" content="A collection of professional certifications, accomplishments, and skills verified by industry-leading organizations." />
          <meta property="og:url" content="https://kunaldas.tech/certificates" />
          <link rel="canonical" href="https://kunaldas.tech/certificates" />
        </Helmet>

        <div className="cert-header">
          <Link to="/" className="back-btn">
            <Icon icon="bi:arrow-left" /> Back
          </Link>
          <h2><span>All my</span> sweats are not here</h2>
          <div style={{ width: 100 }} className="d-none d-md-block" /> {/* Spacer for centering */}
        </div>

        <div className="cert-grid">
          {certificates.map((cert, idx) => (
            <div key={idx} className="cert-card" onClick={() => setSelected(cert)}>
              <div className="cert-img-wrapper">
                <img src={cert.src} alt={cert.title} loading="lazy" />
              </div>
              <div className="cert-info">
                <h3>{cert.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selected && (
        <div className="cert-modal" onClick={() => setSelected(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelected(null)} aria-label="Close">
              <Icon icon="bi:x" />
            </button>
            <div className="modal-img-container">
              <img src={selected.src} alt={selected.title} />
            </div>
            <h3>{selected.title}</h3>
          </div>
        </div>
      )}
    </section>
  );
} 